// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22CJ1","content":"styles_content__3ExhB","row":"styles_row__2g1Bg","footer":"styles_footer__3z7-c","phraseLength":"styles_phraseLength__jqwS0"};